import { z } from "zod";
import dialogUiConfig from "./dialogUiConfig";
import { GameType } from "@/types";

const GameFormSchema = z.object({
  name: z.string().min(1, {
    message: dialogUiConfig.gameNameFieldValidationMsg,
  }),
  link: z.string().min(1, {
    message: dialogUiConfig.gameLinkFieldValidationMsg,
  }),
  type: z.enum([GameType.NEURONUP, GameType.GRUBLE, GameType.NRK], {
    message: dialogUiConfig.gameTypeFieldValidationMsg,
  }),
});

export default GameFormSchema;
